import { RESET } from './ForgotPasswordConstants'

export const reset = () => {
  const action = {
    type: RESET,
  }
  return action
}
